// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  env: 'dev',
  entity_id: '1',
  domain: 'https://www.mycareer.proteen.com',
  entity_name: 'ProTeen',
  googleAnalyticsID: 'UA-213971605-1',
  razorPayKey: 'rzp_test_FjzDoZGX9ZzVPB',
  production: false,
  version: "1.0.0.3",
  resourceServerURL: "http://localhost:8081",
  bucketURL: "https://user-import-data.s3.ap-south-1.amazonaws.com/public/",
  social_media: {
    facebookAppId: "409029740393148",
    //facebookAppId:"448100349584536",//rahul
    linkedin: {
      client_id: "78qotif51jqmhg",
      client_secret: "CSq5KOERNkgOLIEb"
    },
    twitter: {
      app_id: '20571634',
      consumer_key: 'fFXOjTFtpG2Sb12U9QhPFrN3G',
      consumer_secret: 'DcZoLRCxcFx0cTGMuRyUKsBlDThlwiqlBGHljOpSCU9ZSKcuif',
      access_token: '113865030-BJquviwjA3Bd4VZKkASxwoWHmCOfnTb8Hd7gQNz1',
      token_secret: 'zMKMi2ZZefVtpjKsZGRpXDOXyU5vkR1vXs9zZkJH0urYO',
    },
    instagram: {
      app_id: '324010449087440'
    }
  },
  minYear: '1980',
  minYearStudent: '2000',
  minYearParent: '1980',
  confirm: {
    username: "",
    email: "",
    phone: "",
    password: "",
    defaultPassword: "Softdel@123",
    role: ""
  },
  apiType: '',
  currentLoginUser: {
    user: {},
    userAttribute: {},
    sessionIdInfo: {}
  },
  assessmentAttempts: 3,
  AWSConfig: {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:39fe9e2b-92e4-4859-9383-908e46372825",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_lEVXCKcgO",
    "aws_user_pools_web_client_id": "4is8nivo571um43sfvbmcl0jk6",
    "authenticationFlowType": 'USER_PASSWORD_AUTH',
    "oauth": {
      "domain": "proteen-webappdev.auth.ap-south-1.amazoncognito.com",
      "scope": [
        "phone",
        "email",
        "openid",
        "profile",
        "aws.cognito.signin.user.admin"
      ],
      //"redirectSignIn": "https://develop.d3bf9b4lgay1rh.amplifyapp.com/proteen/select-role",
      "redirectSignIn": "https://develop.d3bf9b4lgay1rh.amplifyapp.com/proteen/select-role",
      "redirectSignOut": "https://develop.d3bf9b4lgay1rh.amplifyapp.com/proteen/login",
      "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
  },
  ApiConfig: {
    student: "https://cfp68ms7s8.execute-api.ap-south-1.amazonaws.com/dev",
    admin: "https://uwf3qboa2e.execute-api.ap-south-1.amazonaws.com/dev",
    parent: "https://h31dvjmvpe.execute-api.ap-south-1.amazonaws.com/dev",
    settings: "https://g609hfxkz1.execute-api.ap-south-1.amazonaws.com/dev",
    others: "https://g609hfxkz1.execute-api.ap-south-1.amazonaws.com/dev",
    psychometric: "https://cfp68ms7s8.execute-api.ap-south-1.amazonaws.com/dev",
    careerinfo: "https://cfp68ms7s8.execute-api.ap-south-1.amazonaws.com/dev",
    leadsquared: "https://471ajva688.execute-api.ap-south-1.amazonaws.com/dev",
    loginApi: "https://gezhtpth62.execute-api.ap-south-1.amazonaws.com/dev/auth",
    student_ca: "https://cfp68ms7s8.execute-api.ap-south-1.amazonaws.com/custom-auth",

  },
  // added flag to remove/hide proteen related pages from the report 18082023
  remove_proteen: false

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
